import type { FC } from 'react';
import React, { useEffect, useState } from 'react';

import { defaultHandler } from './config';
import type { IEmailSuggestionsData } from './helpers/actions';
import { formatEmail, getEmailSuggestions } from './helpers/actions';
import type { TEmailField } from './models';

export const EmailField: FC<TEmailField> = ({
    Select,
    arrow,
    caption = 'На данный email будет направлена информация по заявке',
    className = '',
    error,
    forwardedRef,
    name = 'email',
    onCancel = defaultHandler,
    onChange = defaultHandler,
    onSelect = defaultHandler,
    placeholder = 'Электронная почта',
    success,
    value: initValue = '',
    dataTestId = 'email-input',
    ...rest
}) => {
    const [currentValue, setValue] = useState(String(initValue));
    const [options, setOptions] = useState<IEmailSuggestionsData[]>([]);

    const handleChange = (value: string) => {
        const formattedValue = formatEmail(value);

        setValue(formattedValue);
        getEmailSuggestions(formattedValue)
            .then(res => setOptions(res))
            .catch(e => console.error(e));

        return formattedValue;
    };

    useEffect(() => {
        if (initValue === currentValue) return;

        handleChange(String(initValue));
    }, [initValue]);

    return (
        <Select
            {...rest}
            arrow={arrow}
            caption={caption}
            className={className}
            dataTestId={dataTestId}
            error={error}
            forwardedRef={forwardedRef}
            name={name}
            onCancel={event => {
                setValue('');
                onCancel(event);
            }}
            onChange={({ value, ...event }) =>
                onChange({ value: handleChange(String(value)), ...event })
            }
            onSelect={({ value, ...event }) => onSelect({ value: handleChange(value), ...event })}
            options={options}
            placeholder={placeholder}
            success={success}
            value={currentValue}
        />
    );
};
